import React, { useContext, useEffect, useState } from 'react';
import { uniqueKey } from '../../common/keys';
import NoData from '../../components/alerts/NoData';
import { getFormPropz } from '../../components/forms/props/formPropz';
import FormForm from '../../components/forms/FormForm';
import { BaseSettingsContext } from '../../cnr/contexts/BaseSettingsContext';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';

const SettingsFormEdit = (props) => {

  const { isGlobal, settingsType, previewForm, updateForm, closeForm, formData, useWrapper, inSidebar } = props

  // baseSettingsContext
  const baseSettingsContext = useContext(BaseSettingsContext)
  const { baseSettings_state } = baseSettingsContext ? baseSettingsContext : {}
  const { baseSettings } = baseSettings_state ?? {}

  const [formProps, setFormProps] = useState()
  const [currentFormData, setCurrentFormData] = useState({});

  const handleSaveForm = () => updateForm(currentFormData, settingsType, true)
  const handleUpdateForm = () => previewForm(currentFormData)

  const handleLocalPropChange = (data_form) => {
    useWrapper ? setCurrentFormData(data_form) : updateForm(data_form, settingsType, false)
  }

  useEffect(() => {
    if (settingsType && formData) {
      const { global, page, pageItem } = baseSettings ?? {}
      let aas = isGlobal ? global : page
      if (!isGlobal && pageItem) { aas = pageItem }
      const settingsProps = aas && aas[settingsType] ? aas[settingsType] : {}
      const { groupItems } = settingsProps ? settingsProps : {}
      const vprs = groupItems
      const form_handlers = { handleFormDataChange_local: handleLocalPropChange }
      const fpp = { form_handlers, viewProps: vprs, data_init: formData, settingsType }
      const fprs = getFormPropz(fpp)
      setCurrentFormData(formData)
      setFormProps(fprs)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [settingsType, formData]);

  const content = () => {
    return formProps ?
      <FormForm
        formAttributes={{ inverted: true }}
        formProps={formProps}
        key={uniqueKey('sf', settingsType)}
      />
      :
      <NoData fullCaption={'Missing ' + settingsType} />
  }

  const wrapper = () => <Wrapper
    content={content()}
    footer={<UiSaveButtons
      preview={previewForm ? { oc: handleUpdateForm, caption: 'Preview' } : null}
      save={{ oc: handleSaveForm, caption: 'Save' }}
      cancel={{ oc: closeForm, caption: 'Close' }}
    />
    }
    wrapperType={wrapperTypes.paddedFooter}
    css={{ footer: inSidebar ? 'sbf' : null }}
  />

  return useWrapper ? wrapper() : content()
}

export default SettingsFormEdit